export const UPDATE_TRANSLATION = 'APP_UPDATED_SCREEN'
export const SET_INIT_DATA = 'APP_INIT_DATA'

const initialState = {
  updated_screen: null,
  ...JSON.parse(localStorage.getItem('app_data') ?? '{}'),
}

export default function (
  state = {
    ...initialState,
  },
  action = {}
) {
  switch (action.type) {
    case UPDATE_TRANSLATION:
      return {
        ...state,
        updated_screen: action.screen,
      }
    case SET_INIT_DATA:
      localStorage.setItem('app_data', JSON.stringify(action.data))
      return {
        ...state,
        ...action.data,
      }
    default:
      return state
  }
}
